import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'daccs-no-content',
  templateUrl: './no-content.component.html',
  styleUrls: ['./no-content.component.scss']
})
export class NoContentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/layout/no-content/no-content.component.ts